<div class="add-ticket-type d-flex gap-2 align-items-center">
  <button
    *ngIf="product.qty > 0"
    class="btn btn-sm btn-light d-flex text-muted p-1 rounded-circle"
    (click)="decrementQty(product.qty)"
  >
    <span class="material-symbols-outlined" style="font-size: 20px">
      close
    </span>
  </button>
  <div
    class="d-flex justify-content-between align-items-center bg-white border border-dark position-relative rounded rounded-pill"
  >
    <button
      type="button"
      class="btn-outline-light text-dark pt-1 px-2 pb-0 btn border-0 rounded-circle rounded text-light"
      (click)="decrementQty()"
      [disabled]="product.qty === 0"
    >
      <span class="material-symbols-outlined small-icon">remove</span>
    </button>
    <div class="quantity-label h-100 fw-semibold small text-center">
      {{ product.qty }}
    </div>
    <button
      type="button"
      class="btn-outline-light text-dark pt-1 px-2 pb-0 btn border-0 rounded-circle rounded text-light increase-button"
      (click)="incrementQty()"
      [disabled]="isTicketLimitReached()"
    >
      <span class="material-symbols-outlined small-icon">add</span>
    </button>
  </div>
</div>
